import React from 'react';

import {MainLayout} from 'widgets/layout';

import {EmailDelete} from 'features/profile';

const EmailDeletePage: React.FC = () => {
    return <MainLayout isPlugMode>
        <EmailDelete />
    </MainLayout>;
};

export default EmailDeletePage;